'use strict'

export default (mockAxios) => {
  mockAxios.onDelete(new RegExp(`/mgmt/persons/\\d+`)).reply(200, {
    'success': true,
    'data': {
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/managementPersonRepositoryMock.js